import { useMutation } from '@tanstack/react-query';

import { RegistrationRequestApi } from '@/api/domains/registration-request.api';

export const useSendRegistrationRequest = () => {
  return useMutation({
    mutationFn: RegistrationRequestApi.sendRegistrationRequest,
  });
};
